import { PlanType } from '@efficiently/models';

// TODO EFF-22415
export function planTypeToGraphqlEnumName(type?: PlanType): keyof typeof PlanType | undefined {
	if (!type) {
		return undefined;
	}

	const pair = (Object.entries(PlanType) as [keyof typeof PlanType, PlanType][]).find(([, v]) => v === type);
	if (pair === undefined) {
		throw new Error(`Unknown PlanType: ${String(type)}`);
	}
	return pair[0];
}
